export default "__VITE_ASSET__0e5154b7__"